// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3bSL0","buttons":"RemoveExpirationActionButtons_buttons__1i0yn"};